<template>
  <nav id="app-nav" class="no-print" :class="{'expanded': store.ui.state.nav.open }" @click="store.ui.toggleNav(false)" >
    <div>
      <router-link to="/">
        <AppLogo :icon="!store.ui.state.nav.open" />
      </router-link>
      <div class="nav-item-wrapper" @click="createRoute" v-tooltip="{ text: 'Opret rute', pos: 'right'}">
        <div class="nav-item">
          <AppIcon name="add_circle" /> <span>Opret rute</span>
        </div>
      </div>
      <router-link to="/routes" class="nav-item-wrapper" v-tooltip="{ text: $t('nav.routes'), pos: 'right'}">
        <div class="nav-item">
          <AppIcon name="moving" /> <span>{{ $t('nav.routes') }}</span>
        </div>
      </router-link>
    </div>
    <div>
      <router-link to="/faq" class="nav-item-wrapper" v-tooltip="{ text: $t('nav.faq'), pos: 'right' }">
        <div class="nav-item">
          <AppIcon name="contact_support" /> <span>{{ $t('nav.faq') }}</span>
        </div>
      </router-link>
      <router-link to="/privacy" class="nav-item-wrapper" v-tooltip="{ text: $t('nav.privacy'), pos: 'right' }">
        <div class="nav-item">
          <AppIcon name="security" /> <span>{{ $t('nav.privacy') }}</span>
        </div>
      </router-link>
      <router-link to="/tos" class="nav-item-wrapper" v-tooltip="{ text: $t('nav.tos'), pos: 'right' }">
        <div class="nav-item">
          <AppIcon name="gavel" /> <span>{{ $t('nav.tos') }}</span>
        </div>
      </router-link>
      <div class="divider"></div>
      <template v-if="!user.user.guest">
        <div class="nav-item-wrapper" @click="giveFeedback" v-tooltip="{ text: $t('nav.feedback'), pos: 'right' }">
          <div class="nav-item">
            <AppIcon name="feedback" /> <span>{{ $t('nav.feedback') }}</span>
          </div>
        </div>
        <div class="nav-item-wrapper" @click="changeTheme" v-tooltip="{ text: theme == 'dark' ? $t('nav.light_mode') : $t('nav.dark_mode'), pos: 'right'}">
          <div class="nav-item">
            <AppIcon :name="theme == 'dark' ? 'wb_sunny' : 'brightness_2'"/> <span>{{ theme == 'dark' ? $t('nav.light_mode') : $t('nav.dark_mode') }}</span>
          </div>
        </div>
        <div class="divider"></div>
      </template>
      <div class="nav-item-wrapper no-mobile" @click.stop="store.ui.toggleNav()">
        <div class="nav-item">
          <AppIcon :name="store.ui.state.nav.open ? 'chevron_left' : 'chevron_right'"/> <span>Minimér menu</span>
        </div>
      </div>
      <router-link to="/account" v-if="!user.user.guest" class="nav-item-wrapper nav-item-account" >
        <UserAvatar :user="user.user" :subscription="user.subscription" style="margin: 0 1.25rem" />
        <div v-if="store.ui.state.nav.open" class="flex flex-sb fill-x" style="overflow:hidden;
        ">
          <div class="fill-x">
            <div class="text-b text-overflow-ellipsis">{{ user.user.name }}</div>
            <div class="text-overflow-ellipsis">{{ user.user.email }}</div>
          </div>
        </div>
      </router-link>
    </div>
  </nav>

  <nav id="app-nav-mobile">
    <div>
      <AppIcon name="menu" @click="store.ui.toggleNav()" />
    </div>

    <template v-if="!user.user.guest">
      <div>
        <router-link to="/routes"><AppIcon name="moving" /></router-link>
      </div>
      <div>
        <AppIcon name="add_circle" style="font-size:2.25rem;" @click="createRoute" />
      </div>
      <div>
        <AppIcon :name="theme == 'dark' ? 'wb_sunny' : 'brightness_2'" @click="changeTheme" />
      </div>
    </template>
    <template v-else>
      <div>
        <AppButton class="color-primary" @click="signIn">Opret bruger / Log ind</AppButton>
      </div>
    </template>

    <div>
      <router-link to="/account">
        <UserAvatar v-if="!user.user.guest" :user="user.user" size="small"/>
        <AppIcon v-else name="account_circle" />
      </router-link>
    </div>
  </nav>

  <nav id="app-nav-user" class="card" v-if="false">
    <div class="text-c">
      <UserAvatar :user="user.user" :subscription="user.subscription" size="large" />
      <div>{{ user.user.name }}</div>
      <div>{{ user.user.email }}</div>
    </div>
    <AppButton color="error" icon="exit_to_app" fill>Sign out</AppButton>
  </nav>

  <div class="mask" :class="{'visible': state.expanded}" @click="state.expanded = false"></div>
</template>

<script>
import { store } from '@/store'
import { defineComponent, reactive, computed } from 'vue'

import AppLogo from '@/components/atoms/AppLogo.vue'
import UserAvatar from '@/components/user/UserAvatar.vue'

export default defineComponent({
  name: 'AppNav',
  components: { AppLogo, UserAvatar },
  setup() {
    const state = reactive({
      expanded: false
    })
    const user = computed(() => store.user.state)
    const theme = store.global.get(state => state.theme)
    function changeTheme() {
      store.global.changeTheme()
    }

    function toggleNav() {
      store.ui.mutate(state => state.nav.open = !state.nav.open)
    }

    function signIn() {
      store.modal.showModal('SignIn')
    }
    function giveFeedback() {
      store.modal.showModal('GiveFeedback')
    }
    function createRoute() {
      store.user.createRoute()
    }

    return { state, store, theme, user, toggleNav, changeTheme, giveFeedback, createRoute, signIn }
  }
})
</script>

<style lang="scss">

.mask {
  opacity: 0;
  pointer-events: none;
  &.visible {
    opacity: 1;
    pointer-events: all;
  }
}

.router-link-active {
  .user-avatar:before {
    content: '';
    position: absolute;
    top: -.4rem;
    left: -.4rem;
    bottom: -.4rem;
    right: -.4rem;
    border: 3px solid var(--color-primary);
    border-radius: 100%;
  }
}

#app-nav-mobile {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  height: var(--nav-mobile-height);
  display: var(--display-mobile);
  background: var(--color-page);
  border-top: 1px solid var(--color-divider);
  z-index: 10000001;
  > div {
    flex:1;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .icon {
      font-size: 1.75rem;
  }
  .router-link-active {
    .icon {
      color: var(--color-primary);
    }
  }
}

#app-nav {
    position: fixed;
    top: 0;
    left: 0;
    bottom: var(--margin-bottom);
    padding-bottom: 1rem;
    width: var(--nav-width);
    background: var(--color-nav);
    border-right: 1px solid var(--text-color-tertiary);
    backdrop-filter: blur(8px);
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    //overflow: hidden;
    transition: transform .3s;
    z-index: 0;
    width: var(--nav-width);

    &.expanded {
      width: 20rem;

      .nav-item {
        span {
          opacity: 1;
          display: block;
        }
      }
    }
    .nav-item-wrapper {
      cursor: pointer;
      display: flex;
      align-items: center;
      text-decoration: none;
      color: var(--text-color-secondary);
      position: relative;
      padding: 0 1.75rem;
      height: 2.5rem;
      white-space: nowrap;

      .icon {
        transition: transform .4s;
      }

      &:before {
        content: '';
        position: absolute;
        background: var(--text-color-tertiary);
        z-index: -1;
        top: 0;
        left: 1rem;
        right: 1rem;
        bottom: 0;
        border-radius: 1rem;
        opacity: 0;
        transition: all .4s;
      } 

      &:after {
        content: '';
        position: absolute;
        top: 0;
        bottom: 0;
        left: 0;
        width: .25rem;
        transition: transform .4s;
        transform: scaleX(0);
        border-top-right-radius: 4px;
        border-bottom-right-radius: 4px;
      }

      &:hover {
        //background: var(--text-color-tertiary);
        &:before {
          opacity: 1;
        }
      }
      &:active {
        &:before {
          opacity: 1;
          left: 0;
          right: 0;
          border-radius: 0;
        }
        .icon {
          transform: scale(1.1);
        }
      }

      &.router-link-active {
        &:after {
          background: var(--color-primary);
          transform: scaleX(1);
        }
        color: var(--color-primary);
        span {
          color: var(--color-primary);
        }
      }
    }
    .nav-item-account {
      height: 3rem;
      margin: 1rem 0 0 0;
      padding: 0 1rem 0 0;
      &:after {
        top: 0;
        bottom: 0;
      }
    }

    .nav-item {
      display: flex;
      align-items: center;

      span {
        color: var(--text-color-primary);
        font-weight: 500;
        font-size: 1rem;
        margin-left: 1rem;
        //transition: opacity .3s;
        display: none;
        letter-spacing: .25px;
      }
    }

  #app-logo {
    height: 5rem;
    padding: 1.5rem 0;
    padding-left: 1.125rem;
    svg {
      height: 2.25rem;
    }
  }

}




#app-nav-guest {
  position: fixed;
  padding: 1.25rem;
  margin-left: var(--margin-left);
  top: 0;
  right: 0; 
  left: 0;
  display: flex;
  z-index: 10;
  justify-content: space-between;
}



#app-nav-user {
  position: absolute;
  top: 4rem;
  right: 1rem;
  z-index: 1;
  padding: 1rem;
}


</style>